//1. Variable And Declaration
//import {Modal} from 'bootstrap';
import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';
import { gsap } from "gsap";
import { ScrollSmoother } from "gsap/ScrollSmoother";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
import LightBoxVideo from "../modules/LightBoxVideo"
import ImageParallax from '../modules/ImageParallax';
import GspAnimate from "../modules/GspAnimate";
gsap.registerPlugin(ScrollTrigger,ScrollSmoother,ScrollToPlugin);
import Navbar from '../modules/Navbar'

const videos = document.querySelectorAll('.js-achievement-video')
Array.from(videos).map(v => {
	new LightBoxVideo(v)
})
new ImageParallax();
const gspAnimate=new GspAnimate

const navbar=new Navbar();
let sectionID=navbar.getSectionId()

let scroller;
function initScrollSmoth(){
	scroller=ScrollSmoother.create({
		smooth: 1,             // how long (in seconds) it takes to "catch up" to the native scroll position
		effects: true,           // looks for data-speed and data-lag attributes on elements
		smoothTouch: 0.1,        // much shorter smoothing time on touch devices (default is not smoothing on touch devices)
	});
}
initScrollSmoth();

const swiperLearningContainer=document.querySelector(".swiperLearning");
const swiperLearning = new Swiper('.swiperLearning', {
    centeredSlides: true,
    spaceBetween: 30,
    slidesPerView:2,
    initialSlide: 1,
    loop:true,
    freeMode: true,
    speed: 8000,
    autoplay: {
        delay: 1,
    },
    pagination: {
        el: ".swiper-pagination",
        clickable: true,
    },
});


////2. Event
window.addEventListener("load", function(){
	gspAnimate.gspFadeUp();
	if (window.innerWidth >= 768) {
        mouseFollow();
	}

	if(sectionID=='organization'){
		navbar.scrollToSection('#organization')
	}
	if(sectionID=='welfare'){
		navbar.scrollToSection('#welfare')
	}
	if(sectionID=='history'){
		navbar.scrollToSection('#history')
	}
	if(sectionID=='achievement'){
		navbar.scrollToSection('#achievement')
	}
	if(sectionID=='message'){
		navbar.scrollToSection('#message')
	}

	
});
window.addEventListener("resize", function(){
	if (window.innerWidth >= 768) {
        mouseFollow();
	} 
});

swiperLearningContainer.addEventListener("mouseenter",() => {
    swiperLearning.autoplay.stop();
});
swiperLearningContainer.addEventListener("mouseleave",() => {
    swiperLearning.autoplay.start();
});

let swiperHistoryThumbnail = new Swiper(".swiperHistoryThumbnail", {
    direction: "vertical",
    centeredSlides: true,
    slidesPerView: 5,
    loop: true,
    watchSlidesProgress: true,
    freeMode: true,
});

new Swiper(".swiperHistory", {
    loop: true,
    spaceBetween: 10,
    direction: "vertical",
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
    },
    thumbs: {
        swiper: swiperHistoryThumbnail,
    },
});

let sectionHistory = document.querySelector(".about-history");
let historySideTitle = document.querySelector(".about-history__side-title");
if (sectionHistory && historySideTitle ) {
	ScrollTrigger.create({
		trigger: '.about-history__side-title',
		start: '-300px top',
		end: () => `+=${sectionHistory.offsetHeight - (historySideTitle.offsetWidth+ 300)}`,
		pin: '.about-history__side-title',
	})
}

ScrollTrigger.create({
    trigger: '.about-history__sidebar-list',
    start: '-300px top',
    end: () => `+=${sectionHistory.offsetHeight - 800}`,
    pin: '.about-history__sidebar-list',
    id: "sidemenu",
    //markers: true
})

// const navLinks = gsap.utils.toArray(".about-history__sidebar-link");
let links = gsap.utils.toArray(".about-history__sidebar-link");
links.forEach(a => {
    let element = document.querySelector(a.getAttribute("href")),
    linkST = ScrollTrigger.create({
            trigger: element,
            start: "center top",
            //markers:true,
            id:"panel"

    });
    ScrollTrigger.create({
        trigger: element,
        start: "top center",
        end: "bottom center",
        //markers:true,
        id:"sidenav",
        onToggle: self => self.isActive && setActive(a)
    });
    a.addEventListener("click", e => {
        e.preventDefault();
        // setActive(a)
        gsap.to(window, {duration: 0.1, scrollTo:linkST.start-(element.offsetHeight + 50) , overwrite: "auto"});
    });
});

//3.Function
function setActive(link) {
    links.forEach(el => el.classList.remove("active"));
    links.forEach(el => el.parentElement.classList.remove("active"));
    links.forEach(el => document.querySelector(el.getAttribute("href")).classList.remove("active"));
    link.classList.add('active');
    link.parentElement.classList.add('active');
    let getHref = document.querySelector(link.getAttribute("href"));
    getHref.classList.add('active');
}


let sectionOrganization = document.querySelector(".about-organization-wrapper");
let organizationSideTitle = document.querySelector(".about-organization__side-title");
if (sectionOrganization && organizationSideTitle ) {
	ScrollTrigger.create({
		trigger: '.about-organization__side-title',
		start: '-100px top',
		end: () => `+=${ sectionOrganization.offsetHeight - (organizationSideTitle.offsetWidth+100)}`,
        //end: () => {console.log('teste')},
		pin: '.about-organization__side-title',
        //markers:true
	})
}

let sectionProfileContainer = document.querySelector(".about-profile__container");
let profileSideTitle = document.querySelector(".about-profile__side-title");
if (sectionProfileContainer && profileSideTitle ) {
	ScrollTrigger.create({
		trigger: profileSideTitle,
		start: '-100px top',
		end: () => `+=${ sectionProfileContainer.offsetHeight - (profileSideTitle.offsetWidth+200)}`,
		pin: profileSideTitle,
        //markers:true
	})
}

let sectionLearningContainer = document.querySelector(".about-learning__container");
let learningSideTitle = document.querySelector(".about-learning__side-title");
if (sectionLearningContainer && learningSideTitle ) {
	ScrollTrigger.create({
		trigger: learningSideTitle,
		start: '-100px top',
		end: () => `+=${ sectionLearningContainer.offsetHeight - (learningSideTitle.offsetWidth)}`,
		pin: learningSideTitle,
        //markers:true
	})
}

let sectionWelfareContainer = document.querySelector(".about-welfare__container");
let welfareSideTitle = document.querySelector(".about-welfare__side-title");
if (sectionWelfareContainer && welfareSideTitle ) {
	ScrollTrigger.create({
		trigger: welfareSideTitle,
		start: '-100px top',
		end: () => `+=${ sectionWelfareContainer.offsetHeight - (welfareSideTitle.offsetWidth + 100)}`,
		pin: welfareSideTitle,
        //markers:true
	})
}

let sectionAchievementContainer = document.querySelector(".about-achievement__container");
let achievementSideTitle = document.querySelector(".about-achievement__side-title");
if (sectionAchievementContainer && achievementSideTitle ) {
	ScrollTrigger.create({
		trigger: achievementSideTitle,
		start: '-100px top',
		end: () => `+=${ sectionAchievementContainer.offsetHeight - (welfareSideTitle.offsetWidth + 300)}`,
		pin: achievementSideTitle,
        //markers:true
	})
}

let sectionCEOContainer = document.querySelector(".about-ceo__container");
let CEOSideTitle = document.querySelector(".about-ceo__side-title");
if (sectionCEOContainer && CEOSideTitle ) {
	ScrollTrigger.create({
		trigger: CEOSideTitle,
		start: '-100px top',
		end: () => `+=${ sectionCEOContainer.offsetHeight - (CEOSideTitle.offsetWidth + 100)}`,
		pin: CEOSideTitle,
        //markers:true
	})
}



const sectionsSideTitleMobile = gsap.utils.toArray('.section-title__side-left--mobile')
sectionsSideTitleMobile.forEach( function(sectionSideTitleMobile) {
	gsap.to(sectionSideTitleMobile, {
		xPercent: -150,
		ease: "none",
		scrollTrigger: {
			trigger: sectionSideTitleMobile,
			start: "top center",
			end: "bottom top",
			scrub: true,
		}
	})
})

const sectionsSideTitleRightMobile = gsap.utils.toArray('.section-title__side-right--mobile')
sectionsSideTitleRightMobile.forEach( function(sectionSideTitleRightMobile) {
	gsap.to(sectionSideTitleRightMobile, {
		xPercent: -150,
		ease: "none",
		scrollTrigger: {
			trigger: sectionSideTitleRightMobile,
			start: "top center",
			end: "bottom top",
			scrub: true,
		}
	})
})

function mouseFollow(){
	let locationButton = document.querySelector('.locations-two__button');
	let locationButtonText = document.querySelector('.locations-two__button-text');
	let locationFollowArea = document.querySelectorAll('.slide-learning');

	function moveCircle(e) {
		gsap.to(locationButton,{
			left: e.clientX,
			top: e.clientY,
			duration:0.25
		// autoAlpha:1,
		});
	}
	document.body.addEventListener('mousemove', moveCircle);

	locationFollowArea.forEach(function(el) {
		el.addEventListener('mouseover', () => {

			let cursorName=document.querySelector(".locations-two__button-text");
			cursorName.innerHTML="Drag";
			gsap.to(locationButton, {
				scale: 1,
				autoAlpha: 1,
				duration:0.25
			});
		});
		el.addEventListener('mouseout', () => {
			gsap.to(locationButton, {
				scale: 0.5,
				autoAlpha: 0,
				duration:0.25
			});
		});
		el.addEventListener('mousedown', () => {
			gsap.to(locationButton,  {
				css: { transform: `translate(-50%, -50%) scale(0.75)` },
				duration:0.5
			});
			gsap.to(locationButtonText, {
				css: { opacity: 1  },
				duration:0.25
			});
		});

		el.addEventListener('mouseup', () => {
			gsap.to(locationButton, {
				css: { background: `transparent` },
				duration:1
			});
			gsap.to(locationButton, {
				css: { transform: `translate(-50%, -50%) scale(1)` },
				duration:0.5
			});
			gsap.to(locationButtonText,{
				css: {
					opacity: 1
				},
			duration:0.25
			});
		});
	})
}